import { useEffect } from "react"
import { useLocalStorage } from "../../../hooks/external/local-storage"
import { ColorMode } from "."
import useMediaQuery from "../../../hooks/external/media-query"

export type UseDarkModeReturn = [ColorMode, (mode: ColorMode) => void]

const COLOR_MODE_KEY = "useDarkMode";

export default function useDarkMode(): UseDarkModeReturn {
    const defaultValue = <ColorMode | null>localStorage.getItem(COLOR_MODE_KEY);
    const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const aggregateMode: ColorMode = defaultValue ?? (prefersDarkMode ? 'dark' : 'light');

    const [mode, setMode] = useLocalStorage<ColorMode>(COLOR_MODE_KEY, aggregateMode);

    useEffect(() => {
        document.body.setAttribute('theme', mode)
    }, [mode])

    return [mode, setMode];
}